// TSS vite/02 — centralized constants.
// Storage keys live here so a rename happens in one place.

export const STORAGE_KEYS = {
    LOGOUT_SIGNAL: 'logout_signal',
    UI_PREFS:      'ui_prefs',
    RAPI_TICKETS:  'rapichontico_tickets',
};
